const acoesDJ = {
  AGUARDANDO_ANALISE_ASSESSOR_DJ: {
    nome: 'Assesor',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'AGUARDANDO_ANALISE.ASSESSOR.DJ'
  },
  AGUARDANDO_ANALISE_PROCURADOR_DJ: {
    nome: 'Procurador',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'AGUARDANDO_ANALISE.PROCURADOR.DJ'
  },
  AGUARDANDO_ANALISE_ADVOGADO_DJ: {
    nome: 'Advogado',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'AGUARDANDO_ANALISE.ADVOGADO.DJ'
  },
  AGUARDANDO_ANALISE_PROCURADOR_JURIDICO_DJ: {
    nome: 'Procuradoria Jurídica',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'AGUARDANDO_ANALISE.PROCURADOR_JURIDICO.DJ'
  },
  AGUARDANDO_ANALISE_PROCURADOR_ADMINISTRATIVO_DJ: {
    nome: 'Procuradoria Administrativa',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'AGUARDANDO_ANALISE.PROCURADOR_ADMINISTRATIVO.DJ'
  },
  SOLICITAR_ARQUIVAMENTO_DIRETOR_GDA_AUTOCOMPLETE: {
    nome: 'Encaminhar para a Presidência',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'SOLICITAR_ARQUIVAMENTO.DIRETOR.GDA.AUTOCOMPLETE'},
  ENCAMINHAR_GERENTE_GCG_AUTOCOMPLETE: {
    nome: 'Encaminhar para a GCG',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'ENCAMINHAR.GERENTE.GCG.AUTOCOMPLETE'
  },
  ENCAMINHAR_SISTEMA_CDI_AUTOCOMPLETE: {
    nome: 'Encaminhar para a CDI',
    acao: 'ACAO_ANALISE',
    valor: 'ENCAMINHAR.SISTEMA.CDI.AUTOCOMPLETE'
  },
  RETORNO_SISTEMA_ANTERIOR: {
    nome: 'Retornar setor',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'RETORNO.SISTEMA.ANTERIOR'
  },
  ENCAMINHAR_DIRETOR_GP_AUTOCOMPLETE: {
    nome: 'Encaminhar para a Presidência',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'ENCAMINHAR.DIRETOR.GP.AUTOCOMPLETE'
  },
  AGUARDANDO_ANALISE_DIRETOR_JURIDICO_DJ: {
    nome: 'Diretoria Jurídica',
    tipoAcao: 'ACAO_ANALISE',
    valor: 'AGUARDANDO_ANALISE.DIRETOR_JURIDICO.DJ'
  }
}

export default acoesDJ



// WEBPACK FOOTER //
// ./src/utils/ma/acoesDJ.js